import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import BlogSidebar from '../../components/blog-sidebar'
import BlogComments from '../../components/blog-comments'
import BlogAbout from '../../components/blog-about'
import Footer from '../../components/footer'

import bg from '../../assets/images/bg.jpg'

export default function BlogAudioPost() {
  return (
    <>
     <Navbar/> 

      <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">HTML Audio Post</h4>
                            <p className="text-muted mb-0">We present and write attractive blog posts with Sidebar</p>                                        
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Blog</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">HTML Audio Post</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
      </section>
      <ShapeTwo/>

      <section className="section">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 col-md-6">
                    <div className="card blog blog-primary border-0 rounded-0">
                        <div className="card-title mb-0">
                            <div className="section-title text-center">
                                  <Link to="#!" className="text-primary h6 text-decoration-underline">HTML Audio</Link>
                                    <h4 className="my-2">Sorry (Creepa x Subsets x TEOS)</h4>
        
                                    <span className="text-muted mb-0">15th March 2023</span>
                            </div>

                            <div className="mt-4"></div>
                            <iframe className="videoembed rounded shadow" src="https://w.soundcloud.com/player/?visual=true&amp;url=https://soundcloud.com/teo-8/sorry-creepa-x-subsets-x-teos&amp;show_artwork=true&amp;maxwidth=1170&amp;maxheight=1000&amp;dnt=1" style={{height: '433px', width: '100%'}} title='audio'></iframe>

                        </div>
                        <BlogAbout/>
                    </div>
                    <BlogComments/>
                </div>
                <div className="col-lg-4 col-md-6">
                    <BlogSidebar/>
                </div>
            </div>
        </div>
      </section>
      <Shape/>
      <Footer/>
    </>
  )
}
